export default {"src":"/_next/static/media/my-projects-icon.7ced7398.svg","height":16,"width":16};